import { storeService } from "../../services";
import { customToast } from "../../../../shared";
import { toastTypes } from "../../../shared-screens/constants";
import { storesConstants } from "../../constants";
import {
  success,
  withSpinner,
  request,
} from "../../../../redux/actions/utilities";

const {
  BRAND_ID,
  RESET_STORE,
  FETCH_ALL_STORE,
  FETCH_ALL_BRANDS,
  FETCH_STORE_BY_ID,
  FETCH_BRAND_LOCATIONS,
  FETCH_ALL_STORE_BY_BRAND_ID,
  GET_ALL_BRANDS_FOR_FILTER_DROPDOWN,
} = storesConstants;

//Getting all stores details
export const getAllStores = (queryString) => (dispatch) => {
  return withSpinner(dispatch, FETCH_ALL_STORE, () =>
    storeService
      .getAllStores(queryString)
      .then(
        (response) => {
          dispatch(success(response, FETCH_ALL_STORE));
          return response;
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Getting all stores details by brand Id
export const getAllStoresByBrandId = (BrandId) => (dispatch) => {
  withSpinner(dispatch, FETCH_ALL_STORE_BY_BRAND_ID, () =>
    storeService
      .getAllStoresByBrandId(BrandId)
      .then(
        (response) => {
          dispatch(success(response, FETCH_ALL_STORE_BY_BRAND_ID));
        },
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Gets all the active brands
const getAllBrands = (isActiveOnly) => (dispatch) => {
  withSpinner(dispatch, FETCH_ALL_BRANDS, () =>
    storeService
      .getAllBrands(isActiveOnly)
      .then(
        (response) => dispatch(success(response, FETCH_ALL_BRANDS)),
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Gets all the active brands
const getAllBrandForFilterDropdown = () => (dispatch) => {
  withSpinner(dispatch, GET_ALL_BRANDS_FOR_FILTER_DROPDOWN, () =>
    storeService
      .getAllBrands(false)
      .then(
        (response) =>
          dispatch(success(response, GET_ALL_BRANDS_FOR_FILTER_DROPDOWN)),
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Gets the brand locations against brand Id
const getStoresAgainstBrandId = (brandId) => (dispatch) => {
  withSpinner(dispatch, FETCH_BRAND_LOCATIONS, () =>
    storeService
      .getStoresAgainstBrandId(brandId)
      .then(
        (response) => dispatch(success(response, FETCH_BRAND_LOCATIONS)),
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Function to reset brand locations from redux
const resetStores = () => (dispatch) =>
  dispatch(request([], FETCH_BRAND_LOCATIONS));

//Getting store by id
const getStoreById = (brandId) => (dispatch) => {
  storeService.getStoreById(brandId).then(
    (response) => dispatch(success(response, FETCH_STORE_BY_ID)),
    (error) => {
      customToast(error[0], toastTypes.ERROR);
    }
  );
};

//Getting store by id
const setBrandIdInRedux = (id) => (dispatch) => {
  dispatch(success(id, BRAND_ID));
};

//Empty all stores from redux
const emptyAllStores = () => (dispatch) => dispatch(success([], RESET_STORE));

//Gets the stores against group Id
const getStoresAgainstGroupId = (groupId) => (dispatch) => {
  withSpinner(dispatch, FETCH_BRAND_LOCATIONS, () =>
    storeService
      .getStoresAgainstGroupId(groupId)
      .then(
        (response) => dispatch(success(response, FETCH_BRAND_LOCATIONS)),
        (error) => {
          customToast(error[0], toastTypes.ERROR);
        }
      )
  );
};

//Exporting functions for other files
export const storeActions = {
  resetStores,
  getAllStores,
  getAllBrands,
  getStoreById,
  emptyAllStores,
  setBrandIdInRedux,
  getStoresAgainstBrandId,
  getStoresAgainstGroupId,
  getAllStoresByBrandId,
  getAllBrandForFilterDropdown,
};
